class ConfirmModalInnerDialogController {
    
    private callback:Function; //injected from modal-service
    
    public heading: string;
    public content: string;
	
	// @ngInject
	constructor(){}
	
	public onConfirm = () => {
	    this.closeDialog(true);
	}
	
    private closeDialog = (confirm = false) =>{
		this.callback(confirm);
	}
    
}

class ConfirmModalInnerDialog {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
	    heading: "=",
	    content: "=?",
		callback:'='
	};

	public controller = ConfirmModalInnerDialogController;
	public controllerAs = 'confirmDialog';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/confirm-modal-inner-dialog.html';

	public static Factory() {
		return () => new this();
	}
}

export { ConfirmModalInnerDialog };
